import type { Point } from 'highcharts';

export const findClosestPoint = (points: Point[], targetX: number | undefined) => {
  if (targetX === undefined) {
    return null;
  }
  if (targetX < points[0]?.x) {
    return null;
  }
  let closest: Point | null = null;
  let maxX = -Infinity;

  for (const point of points) {
    if (Number.isNaN(Number(point.y))) continue;

    if (point.x === targetX) {
      return point;
    }
    if (point.x < targetX && point.x > maxX) {
      maxX = point.x;
      closest = point;
    }
  }
  return closest;
};
